import { normalizeConstructImage } from '../../../../../helpers/construct/page-content.helper';
import { type ContentComponent, type HomePageAnimatedSplashContent } from '../../../../../types/construct.types';
import { AnimatedSplash } from '../../../../home-components/animated-splash/animated-splash.component';

export const AnimatedSplashHandler: ContentComponent<HomePageAnimatedSplashContent> = ({ content }) => {
	const {
		fields: { media_image, fallback_image, mobile, media_video, backgroundTracking }
	} = content;
	const video = media_video?.items?.[0]?.detail?.video ?? null;

	return (
		<AnimatedSplash
			image={normalizeConstructImage(media_image)}
			fallbackImage={normalizeConstructImage(fallback_image)}
			video={video}
			mobileImage={normalizeConstructImage(mobile)}
			backgroundTracking={backgroundTracking ?? ''}
			animatedSplashCallToAction={content.fields}
		/>
	);
};
